export default (userLoggedIn) => {
  const isHR = userLoggedIn?.ippisUserData?.userEntitySectors?.some(
    (elEntity) => elEntity.roles?.includes("HR")
  );

  return isHR;
};
